// Saves a CSV string as a file download. Templates and exports must be
// generated in the browser: nothing serves client/public/ (the dev server's
// static dir is ./dist and the build never copies public/), so a static-file
// href falls through to the SPA's index.html and downloads HTML instead.
const downloadCsv = (fileName, csvString) => {
  const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = fileName
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}

export default downloadCsv
